import { Pipe, PipeTransform } from '@angular/core';
import {TipologiaCarrello} from "../models/payment-area/payment-area.model";
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'tipoCarrello',
    standalone: false
})
export class TipoCarrelloPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: number): string {
    const carrelloMyPay = this.translateService.instant('carrello-mypay');
    const carrelloMultiBeneficario = this.translateService.instant('carrello-multi-beneficario');
    const carrelloSconosciuto = this.translateService.instant('carrello-sconosciuto');

    switch (value) {
      case TipologiaCarrello.EnteDiContesto:
        return '';
      case TipologiaCarrello.MyPay:
        return carrelloMyPay;
      case TipologiaCarrello.MultiBeneficiario:
        return carrelloMultiBeneficario;
      default:
        return carrelloSconosciuto;
    }
  }

}
